import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IAffiliateProgramTrackersListItem } from '../types';
import {
  AFFILIATE_PROGRAM_TRACKERS_LIST_API_URL,
  AFFILIATE_PROGRAM_TRACKERS_LIST_QUERY_KEY,
  AFFILIATE_PROGRAM_TRACKERS_PERMISSIONS,
} from '../constants';

export default function useAffiliateProgramTrackersListQuery(
  tableState: Ref<ITableState>,
): IContextQueryResult<ITableDataResponse<IAffiliateProgramTrackersListItem>, Error> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IAffiliateProgramTrackersListItem>>({
    queryKey: [AFFILIATE_PROGRAM_TRACKERS_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IAffiliateProgramTrackersListItem>>(
      AFFILIATE_PROGRAM_TRACKERS_LIST_API_URL,
      tableState.value,
      {
        signal,
        permission: AFFILIATE_PROGRAM_TRACKERS_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
